import React from 'react';
import styled from 'styled-components';
import InvisibleBackdrop from 'components/InvisibleBackdrop';
import { navigationCollapsedWidth } from 'constants/sizes';
import { vieurekaBlue } from 'constants/colors';
import navMenu from 'assets/images/nav_menu.svg';
import navMenuArrow from 'assets/images/nav_menu_arrow.svg';
import Menu from './Menu';

type PropTypes = {
  isVisible: boolean;
  onToggleNavigation: () => void;
};

const Navigation: React.FC<PropTypes> = ({ isVisible, onToggleNavigation }) => {
  return (
    <>
      <NavigationContainer $isVisible={isVisible}>
        <ToggleButton
          onClick={onToggleNavigation}
          $backgroundImage={isVisible ? navMenuArrow : navMenu}
        />
        <Menu />
      </NavigationContainer>
      <InvisibleBackdrop
        hidden={!isVisible}
        $zIndex={19}
        onMouseOverCapture={onToggleNavigation}
      />
    </>
  );
};

type ContainerProps = {
  $isVisible: boolean;
};
const NavigationContainer = styled.nav<ContainerProps>`
  position: relative;
  z-index: 20;
  flex-shrink: 0;
  width: ${({ $isVisible }) =>
    $isVisible ? '260px' : `${navigationCollapsedWidth}px`};
  height: 100%;
  background-color: ${vieurekaBlue};
  transition: width 0.2s linear;

  ul {
    left: ${({ $isVisible }) => ($isVisible ? '0' : '-260px')};
    transition: left 0.2s linear;
  }
`;

type ToggleButtonProps = {
  $backgroundImage: string;
};
const ToggleButton = styled.button<ToggleButtonProps>`
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 40px;
  background-color: transparent;
  background-image: url(${({ $backgroundImage }) => $backgroundImage});
  background-repeat: no-repeat;
  background-position: 50%;
  border: 0;
  transition: background-image 0.2s ease;

  &:hover {
    outline: none;
  }
`;

export default Navigation;
